<h1 class="game-board-header" [routerLink]="['/create']">
  Dystopia
</h1>